import React from 'react';
import { MdSearch } from 'react-icons/md';
import { CATEGORY_COLORS } from '../utils/colorScheme';

const FilterPanel = ({
  categories,
  selectedCategory,
  onCategoryChange,
  translations,
  onSearch,
}) => {
  return (
    <div className="mb-8 bg-white border border-slate-200 rounded-xl px-5 py-4">
      
      {/* Search */}
      <div className="relative mb-5">
        <MdSearch className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400 w-[18px] h-[18px]" />
        <input
          type="text"
          placeholder={translations.searchPlaceholder || 'Search crops'}
          onChange={(e) => onSearch(e.target.value)}
          className="
            w-full h-11 pl-9 pr-4 text-sm
            border border-slate-300 rounded-lg
            text-slate-800 placeholder-slate-400
            outline-none transition
            focus:border-emerald-500 focus:ring-1 focus:ring-emerald-200
          "
        />
      </div>

      {/* Filters */}
      <div className="flex flex-wrap gap-2">
        <button
          onClick={() => onCategoryChange('all')}
          className={`
            px-4 h-9 rounded-md text-sm font-medium
            border transition
            ${
              selectedCategory === 'all'
                ? 'bg-emerald-600 text-white border-emerald-600'
                : 'bg-white text-slate-700 border-slate-300 hover:bg-slate-100'
            }
          `}
        >
          {translations.allCategories}
        </button>

        {categories.map((cat) => {
          const isActive = selectedCategory === cat;
          const color = CATEGORY_COLORS[cat] || '#85BF35';

          return (
            <button
              key={cat}
              onClick={() => onCategoryChange(cat)}
              className={`
                px-4 h-9 rounded-md text-sm font-medium
                border transition
                ${
                  isActive
                    ? 'text-white'
                    : 'bg-white text-slate-700 border-slate-300 hover:bg-slate-100'
                }
              `}
              style={{
                backgroundColor: isActive ? color : undefined,
                borderColor: isActive ? color : undefined,
              }}
            >
              {translations.catNames?.[cat] || cat}
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default FilterPanel;
